module.exports = __webpack_public_path__ + "media/img/ceo-ashida-f3bfe482.jpg";